import axios from "../../../utils/axios";
import {
    IAuthFailureLog,
    ISendOtpCode,
    ISendOtpCodeResponse,
    IValidateUser,
    IVerifyOtpCode,
    IVerifyOtpCodeResponse,
} from "../types/auth.types";

export async function validateUser(data: IValidateUser) {
    const response = await axios.post(`/validate-user`, data);
    return response.data;
}

export async function fetchUserDetails() {
    const response = await axios.get(`/user/modern`);
    return response.data;
}

export async function fetchUserPractices(userId: string) {
    const response = await axios.get(`/user/${userId}/practices`);
    return response.data;
}

export async function fetchAuthorizeNetKeys() {
    const response = await axios.get(`/practice/authorize-net-keys`);
    return response.data;
}

export async function encryptAuthFailureEmail(data: IAuthFailureLog) {
    const response = await axios.post(`/auth-failure-log`, data);
    return response.data;
}

export async function sendOtpCode(
    data: ISendOtpCode
): Promise<ISendOtpCodeResponse> {
    const { correlation_id: correlationId, ...payload } = data;
    const response = await axios.post(`/auth/otp/send`, payload, {
        headers: correlationId
            ? { "x-otp-correlation-id": correlationId }
            : undefined,
    });
    return response.data;
}

export async function verifyOtpCode(
    data: IVerifyOtpCode
): Promise<IVerifyOtpCodeResponse> {
    const { correlation_id: correlationId, ...payload } = data;
    const response = await axios.post(`/auth/otp/verify`, payload, {
        headers: correlationId
            ? { "x-otp-correlation-id": correlationId }
            : undefined,
    });
    return response.data;
}
